import { render } from "./breakdown-table.vue?vue&type=template&id=3bce8118&scoped=true&ts=true"
import script from "./breakdown-table.vue?vue&type=script&lang=ts"
export * from "./breakdown-table.vue?vue&type=script&lang=ts"

import "./breakdown-table.vue?vue&type=style&index=0&id=3bce8118&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bce8118"]])

export default __exports__